export const formatPrice = (price) => {
	const num = typeof price === 'number' ? price : Number(price.replace(/,/g, ''));
	return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'KES' }).format(num);
};
